import { Injectable } from '@angular/core';
import { ToastrAlertHelper } from './toastr-alert-helper-service';

@Injectable()
export class CountyHelper {

    allowedRegions = new Set([
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
      ]);

  constructor(private toastrAlertHelper: ToastrAlertHelper) {}

  public validateRegion(letterRegion: string): string {
    const region = letterRegion.toUpperCase();
    if (this.allowedRegions.has(region)) {
      return region;
    } else {
      this.toastrAlertHelper.warning(`Only allow charaters between A and I`);
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/helpers/county-helper.service.ts